import { decorate, inject, injectable } from 'inversify';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import dataAwaitForInvoice from 'mocks/signals/awaitForInvoice.json';

@injectable()
class SignalsMockService {
  constructor() {
    this.dataAwaitForInvoice = dataAwaitForInvoice;
  }

  async getSignalAwaitForInvoice(abortSignal) {
    // eslint-disable-next-line no-console
    console.log(
      `in api getSignalAwaitForInvoice abortSignal = ${JSON.stringify(
        abortSignal,
      )}`,
    );
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.dataAwaitForInvoice.data.items);
      }, 300);
    });
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), SignalsMockService, 0);

export default SignalsMockService;
